import React, { useState } from "react";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomText from "pages/_components/CustomText/CustomText";
import { shape, bool, string, func } from "prop-types";
import FormattedDate from "pages/_components/FormattedDate";
import { TransactionSign } from "pages/_components/TransactionCard";
import Button from "pages/_components/Button";
import Avatar from "pages/_components/Avatar";
import Image from "pages/_components/Image";
import * as i18n from "util/i18n";

const SolicitDebinBody = ({ solicitDebin, status, expirationDate, showMoreData, setShowMoreData, isDesktop }) => {
    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");
    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };

    return (
        <div className="ticket__body echeq-massive-emit">
            <div
                className="grid-table-data flex"
                style={{
                    gridArea: "1 / 1 / span 1 / span 8",
                    justifyContent: "center",
                    flexDirection: "row",
                    textAlign: "center",
                }}>
                <div className="ticket-section flex" style={{ alignItems: "center" }}>
                    <div className="grid-table-data flex align-items-end" style={{ flexDirection: "row" }}>
                        {isDesktop && (
                            <Avatar
                                user={{
                                    userFullName: solicitDebin?.beneficiary?.headline || "",
                                    defaultAvatarId: 0,
                                }}
                            />
                        )}
                        <div className="custom-data" style={{ textAlign: "start", marginLeft: "5px" }}>
                            <CustomText textType="I18N" text="debin.receiver" className="custom-data-title" />
                            <span className="custom-text custom-data-value">
                                {solicitDebin?.beneficiary?.headline || solicitDebin?.beneficiary?.reference}
                            </span>
                            <span className="custom-text custom-data-title">{solicitDebin?.beneficiary?.document}</span>
                        </div>
                    </div>
                    <CustomData
                        keepSpaceIfNotitle
                        dataClass={`amount tag tag-${status.isPending ? "warning" : "echeq-character"}`}
                        titleTextType="I18N"
                        titleText="debin.solicitDebin.amount.label"
                        valueText={solicitDebin?.amountField?.amount}
                        valueTextType={solicitDebin?.amountField?.currency}
                    />
                </div>
            </div>

            <div className="view-more-data-button" id="element-to-ignore">
                <div className="ticket__divider inside-ticket__body">
                    <div className="ticket__notch ticket__notch--left"> </div>
                    <div className="ticket__notch ticket__notch--right"> </div>
                </div>
                <Button
                    aria-expanded={showMoreData ? "true" : "false"}
                    className="more-button"
                    label={buttonLabel}
                    bsStyle="link"
                    onClick={handleSeeMoreData}
                    image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                />
            </div>
            <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                {/* {solicitDebin?.beneficiary?.accountNumber && (
                    <>
                        <div className="ticket-section three-cols">
                            <CustomData
                                titleText="debin.cbu"
                                titleTextType="I18N"
                                valueText={solicitDebin?.beneficiary?.cbu}
                            />
                            <CustomData
                                titleText="debin.emit.emision.label"
                                titleTextType="I18N"
                                valueText={solicitDebin?.beneficiary?.accountNumber}
                            />
                            <CustomData
                                titleText="Banco"
                                titleTextType="TEXT"
                                valueText={solicitDebin?.beneficiary?.localBank}
                            />
                        </div>
                        <div className="ticket__divider inside-ticket__body">
                            <div className="ticket__notch ticket__notch--left"> </div>
                            <div className="ticket__notch ticket__notch--right"> </div>
                        </div>
                    </>
                )} */}
                <div className="emissor-beneficiary">
                    <div className="emissor-data">
                        <h2>{i18n.get("echecks.emissor", "Emisor")}</h2>

                        <CustomData
                            titleText="debin.credit.account"
                            titleTextType="I18N"
                            valueText={`${solicitDebin?.debinAccount?.accountType}****${solicitDebin?.debinAccount?.shortLabel}`}
                        />
                        {/* <CustomData
                            titleText="transfer.sender.label"
                            titleTextType="I18N"
                            valueText={_debitAccount?.ownerName}
                        />
                        <CustomData
                            titleText="ticket.voucher"
                            titleTextType="I18N"
                            valueText={transactionNumber || idTransaction.substring(0, 8).toUpperCase()}
                        /> */}
                    </div>
                    <div className="transaction-arrow">
                        <Image src="images/figma/icon/arrow-right.svg" className="icon-large" />
                    </div>
                    <div className="benefitiary-data">
                        <h2 className="">{i18n.get("echecks.receptor", "Receptor")}</h2>

                        <CustomData
                            titleText="massive.echeck.debit.account"
                            titleTextType="I18N"
                            valueText={solicitDebin?.beneficiary?.accountNumber}
                        />
                        <CustomData
                            titleText="debin.cbu"
                            titleTextType="I18N"
                            valueText={solicitDebin?.beneficiary?.cbu}
                        />
                        {/* valueText={`${solicitDebin?.beneficiary?.recipientDocumentType} ${solicitDebin?.beneficiary?.recipientDocumentNumber}`} */}
                        <CustomData
                            titleText="transfer.bank.label"
                            titleTextType="I18N"
                            valueText={solicitDebin?.beneficiary?.localBank}
                        />
                    </div>
                </div>
                <div className="ticket__divider divider_1 inside-ticket__body">
                    <div className="ticket__notch ticket__notch--left"> </div>
                    <div className="ticket__notch ticket__notch--right"> </div>
                </div>
                <div className="aditional-data">
                    <h2>{i18n.get("creditBill.aditionalData.label", "Datos adicionales")}</h2>
                    <CustomData
                        titleText="debin.received.dateRange.label"
                        titleTextType="I18N"
                        valueText={<FormattedDate date={expirationDate} dateFormat="DD/MM/YYYY h:mm:ss" />}
                    />
                    <CustomData
                        titleText="debin.id"
                        titleTextType="I18N"
                        valueText={solicitDebin?.debinAccount?.productId?.toUpperCase()}
                    />
                    {/* <CustomData
                        titleText="debin.credit.account"
                        titleTextType="I18N"
                        valueText={`${solicitDebin?.debinAccount?.accountType}****${solicitDebin?.debinAccount?.shortLabel}`}
                    /> */}
                    <CustomData
                        titleText="debin.addrecurence.concept.label"
                        titleTextType="I18N"
                        valueText={
                            solicitDebin?.conceptLabel
                                ? `${solicitDebin?.conceptLabel?.id} - ${solicitDebin?.conceptLabel?.name}`
                                : solicitDebin?.concept
                        }
                    />
                    <CustomData
                        titleText="debin.addrecurence.description.label"
                        titleTextType="I18N"
                        valueText={solicitDebin?.description || "-"}
                    />
                </div>
                {status.isFinished ? (
                    <>
                        <div className="ticket__divider divider_1 inside-ticket__body">
                            <div className="ticket__notch ticket__notch--left"> </div>
                            <div className="ticket__notch ticket__notch--right"> </div>
                        </div>
                        <TransactionSign
                            hasVaucher
                            noHorizontalDivider
                            creationTime
                            isSmall
                            isDesktop={isDesktop}
                            showMoreData={showMoreData}
                        />
                    </>
                ) : (
                    <TransactionSign creationTime isSmall isDesktop={isDesktop} showMoreData={showMoreData} />
                )}
            </div>
        </div>
    );
};

SolicitDebinBody.defaultProps = {
    expirationDate: "",
    showMoreData: false,
    setShowMoreData: () => {},
    isDesktop: true,
};

SolicitDebinBody.propTypes = {
    solicitDebin: shape({}).isRequired,
    status: shape({}).isRequired,
    expirationDate: string,
    showMoreData: bool,
    setShowMoreData: func,
    isDesktop: bool,
};

export default SolicitDebinBody;
